import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";
import { IServiceOrderItem } from "../declarations";
import { useGetSailInfoServiceOrderItems } from "../hooks/useGetSailInfoServiceOrderItems";
import { DateTime } from "luxon";

type SailServiceOrderItemsProps = {
    guid: string;
};

const SailServiceOrderItems: React.FC<SailServiceOrderItemsProps> = ({
    guid,
}) => {
    const { data, isLoading } = useGetSailInfoServiceOrderItems(guid);

    if (isLoading || !data) {
        return null;
    }

    return (
        <Card sx={{ width: "100%" }}>
            <CardHeader title="Service History" />
            <CardContent>
                <Grid container spacing={2}>
                    {data.map((feedback: IServiceOrderItem, index: number) => {
                        return (
                            <React.Fragment key={index}>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        Job Description
                                    </Typography>
                                </Grid>{" "}
                                <Grid size={6}>
                                    <Typography variant="body1">
                                        {feedback.jobDescription}
                                    </Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="caption">
                                        Date
                                    </Typography>
                                </Grid>{" "}
                                <Grid size={6}>
                                    <Typography variant="body1">
                                        {DateTime.fromFormat(
                                            feedback.completedDate,
                                            "MM/dd/yyyy hh:mm:ss",
                                        ).toLocaleString(DateTime.DATE_MED)}
                                    </Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Typography variant="body2">
                                        {feedback.fullDsc}
                                    </Typography>
                                </Grid>
                                <Divider sx={{ width: "100%" }} />
                            </React.Fragment>
                        );
                    })}
                    <Grid offset={6} size={6}>
                        <Button
                            size="small"
                            variant="contained"
                            onClick={() => {
                                window.location.replace(
                                    "https://forms.office.com/Pages/ResponsePage.aspx?id=ojYR-ml600aitrgFsV9j_Z5MpaW1D3hOmM5Yi1256hlUOVdTRzJUVFE5NUo1VzdGME9EN1Y2VVZDMi4u&rf8e428c2b6cf4a0aaf98bb4d6992410f=%22%5B%5C%22Hamble%20Point%20Marina%5C%22%5D%22",
                                );
                            }}
                        >
                            New Service Request
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SailServiceOrderItems;
